module.exports = __webpack_public_path__ + "img/boleto.942e12c2.svg";